var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container py-5",attrs:{"id":"Content"}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-md-10 col-lg-8 col-xl-6"},[_c('AccountRole'),_c('AccountEditField')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }